module.exports = window["braintree"]["threeDSecure"];